/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";

import "./App.scss";

function App() {
  const [hasNFC, setHasNFC] = useState<boolean>();
  const [NFCLog, setNFCLog] = useState<string[]>([]);
  const [currentCard, setCurrentCard] = useState("");
  const [gameState, setGameState] = useState("new-game");

  useEffect(() => {
    const scanButton = document.getElementById("scanButton");
    const writeButton = document.getElementById("writeButton");
    const log = (message: string) => {
      console.log(message);
      // document
      //   .getElementById("log")
      //   .appendChild(document.createTextNode(`${message} \n`));
    };
    if (scanButton) {
      const onScanButtonClick = async () => {
        log("User clicked scan button");

        try {
          const reader = new NDEFReader();
          await reader.scan();
          log("> Scan started");
          setGameState("started");

          const handleReaderError = (error: { message: any }) => {
            log(`Argh! Read Error: ${error.message}`);
          };
          reader.addEventListener("error", handleReaderError);

          const handleReaderReading = async (event: any) => {
            const {
              message,
              serialNumber,
            }: {
              message: any;
              serialNumber: any;
            } = event;
            setGameState("new-card");
            console.log(event);
            if (new URLSearchParams(window.location.search).get("debug")) {
              log("> debug");
              debugger;
            }
            log(`Game state: ${JSON.stringify(event.message.records)}`);
            log(`> Serial Number: ${serialNumber}`);
            log(`> Records: (${message.records.length})`);
            const decoder = new TextDecoder();
            for (const record of event.message.records) {
              if (record.mediaType === "application/json") {
                const {level, points, lives} = JSON.parse(decoder.decode(record.data));
                console.log(`You're at level ${level}, with ${points} points and ${lives} lives.`);
              }
            }

            setCurrentCard(serialNumber);
            var cards = document.querySelectorAll(".card");
            cards.forEach((card) =>
              card.addEventListener("click", function () {
                card.classList.toggle("is-flipped");
                setGameState("card-opened");

                setTimeout(() => {
                  setGameState("started");
                  setCurrentCard("");
                }, 5000);
              })
            );
            // const { records } = message;
            // records.forEach((record) => {
            //   log(`>> ${JSON.parse(record).toString()}`);
            // });
          };
          reader.addEventListener("reading", handleReaderReading);

          return () => {
            reader.removeEventListener("error", handleReaderError);
            reader.removeEventListener("reading", handleReaderReading);
          };
        } catch (error) {
          log("Argh! Scan Error " + error);
        }
      };
      scanButton.addEventListener("click", onScanButtonClick);
    }
    if (writeButton) {
      const onWriteButtonClick = async () => {
        log("User clicked write button");

        try {
          log("object creation");
          const encoder = new TextEncoder();
          const gameState = {
            records: [
              {
                id: "my-game-progress",
                recordType: "mime",
                mediaType: "application/json",
                data: encoder.encode(
                  JSON.stringify({
                    level: 3,
                    points: 4500,
                    lives: 3,
                  })
                ),
              },
            ],
          };
          log("writer mode");
          const writer = new NDEFWriter();
          log("write message");
          await writer.write(encoder.encode(JSON.stringify(gameState)));
          log("message written");
        } catch (error) {
          log("Argh write error! " + error);
        }
      };
      writeButton.addEventListener("click", onWriteButtonClick);
    }
  }, [NFCLog, hasNFC, setNFCLog]);

  return (
    <div className={`App ${hasNFC ? "has-nfc" : ""}`}>
      <header className={`App-header ${gameState}`}>
        {gameState === "new-game" && (
          <a className="btn" id="scanButton">
            Start the game
          </a>
        )}
        {gameState === "started" && <h1>Let's play</h1>}
        {gameState === "new-card" && <h1>A wild card appeared...</h1>}
        {gameState === "card-opened" && (
          <h1>
            It's a{" "}
            {currentCard === "04:93:ab:e2:ac:5c:80"
              ? "chance"
              : "community chest"}{" "}
            card!
          </h1>
        )}
        {/* <button id="writeButton">Write</button> */}
        <p id="log" style={{ maxWidth: "100%" }}></p>
        <div>
          {currentCard === "04:93:ab:e2:ac:5c:80" && (
            <div className="scene scene--card">
              <div className="card">
                <div className="card__face card__face--front kans">Chance</div>
                <div className="card__face card__face--back kans">
                  Go to jail.
                </div>
              </div>
            </div>
          )}
          {currentCard === "04:1a:aa:e2:ac:5c:81" && (
            <div className="scene scene--card">
              <div className="card">
                <div className="card__face card__face--front algemeen-fonds">
                  Community chest
                </div>
                <div className="card__face card__face--back algemeen-fonds">
                  Get out of jail, free.
                </div>
              </div>
            </div>
          )}
        </div>
        <a className="btn" id="writeButton">
          Write game state
        </a>
        <ul>
          {NFCLog.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ul>
      </header>
    </div>
  );
}

export default App;
